import type {FC, InputHTMLAttributes} from 'react'

interface Props {
  left?: JSX.Element
  right?: JSX.Element
  validation? : any
  textError? : any
}

const InputDefault: FC<Props & InputHTMLAttributes<HTMLInputElement>> = ({
  left,
  right,
  validation,
  textError,
  ...props

}) => {
  return (
    <>
     <div  className='input-group'>
      {left && <span className='input-group-text'>{left}</span>}
      <input
        {...props}
        type={props?.type || 'text'}
        className={props?.className || 'form-control'}
      />
      {right && <span className='input-group-text'>{right}</span>}
    </div>
    {validation?  <div className='form-label m-2  text-danger bold'>
        {textError}
      </div> : null}
    </>
   
  )
}

export default InputDefault
